<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-body text-center">
      <div class="row">
        <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 28px; margin-bottom: 0">
            {{ existingValue | price }}
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Existing Value
          </p>
        </div>

        <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 28px; margin-bottom: 0">
            {{ forecastValue | price }}
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Forecast Value
          </p>
        </div>

        <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 28px; margin-bottom: 0">
            {{ newValue | price }}
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Avg. New Value pr. month
          </p>
        </div>

        <div class="col-xs-6">
          <p style="font-size: 28px; margin-bottom: 0">
            {{ totalValue | price }}
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Total Value
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: Array
    }
  },

  computed: {
    existingValue() {
      return this.data.filter(row => row.category === 'existing').reduce((sum, row) => sum + row.value, 0)
    },

    forecastValue() {
      return this.data.filter(row => row.category === 'forecast').reduce((sum, row) => sum + row.value, 0)
    },

    newValue() {
      return this.data.filter(row => row.category === 'new').reduce((sum, row) => sum + row.value, 0)
    },

    totalValue() {
      return this.existingValue + this.forecastValue + this.newValue
    }
  }
}
</script>
